export const url = "https://asia-northeast3-heropy-api.cloudfunctions.net/api"
export const headers = {
    "content-type": "application/json",
    "apikey": "FcKdtJs202301",
    "username": "KDT4_Team5"
}